const state = {
  uniqueRequests: {},
}

const getters = {

}

const mutations = {

}

const actions = {
  addUniqueRequest ({ state }, { url, source }) {
    if (state.uniqueRequests[url]) {
      state.uniqueRequests[url].cancel('Operation canceled as unique request.')
    }
    state.uniqueRequests[url] = source
  },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
